import ReactDOM from 'react-dom/client'
import App from './app.tsx'
import 'react-toastify/dist/ReactToastify.css';
import './index.css'
import './utils/i18n.tsx'
import { getContainerId } from './utils/getContainerID.tsx';

const containerId = getContainerId();

ReactDOM.createRoot(document.getElementById(containerId)!).render(
	<App />
)
